module.exports = "https://static.wmbcdn.com/uniweb/images/271a5285c2d8f6a4dd983e6497449bbf.svg";